<template>
  <div>
    <Textbox @input="search" placeholder="Search dataset." />

    <div v-if="itemsLoading" class="flex justify-center py-6">
      <Spinner class="w-10 h-10 text-gray-400" />
    </div>

    <ul class="divide-y divide-gray-200 mt-3" v-else>
      <MySQL
        v-for="item in items"
        :key="item._id"
        :item="item"
        :selected="selectedId"
        :is="provider.connection.adapter?.name"
        :loading="selectedId && itemLoading"
        @select="handleSelect(item, $event)"
      />
    </ul>
  </div>
</template>

<script>
import debounce from "lodash/debounce";
import { defineComponent } from "vue";
import { clean } from "@/lib/helpers";
import Textbox from "@/components/common/fields/Textbox";
import Spinner from "@/components/common/Spinner";
import MySQL from "./MySQL";

export default defineComponent({
  emits: ["update"],

  components: {
    Textbox,
    Spinner,
    MySQL,
  },

  props: {
    link: Object,
    source: Object,
    workflow: Object,
    destination: Object,
  },

  data() {
    return {
      items: [],
      query: "",
      provider: null,
      selectedId: null,
      itemLoading: false,
      itemsLoading: true,
    };
  },

  methods: {
    async load() {
      this.itemsLoading = true;

      try {
        const { data: provider } = await this.$axios.get(
          `/workflows/${this.workflow._id}/nodes/${this.link.provider_id}`
        );

        const { data: items } = await this.$axios.post(`/brokers/datasets`, {
          connection_id: provider.data.connection_id,
          values: clean(provider.data.connection_values),
        });

        this.provider = provider.data;
        this.items = items.data;
      } catch (error) {
        //
      }

      this.itemsLoading = false;
    },

    search: debounce(async function (event) {
      this.query = event?.target.value ?? "";
    }, 300),

    async handleSelect(item, value) {
      this.selectedId = value;
      this.itemLoading = true;

      try {
        const values = {
          dataset: value,
        };

        await this.$axios.put(
          `/workflows/${this.workflow._id}/links/${this.link._id}`,
          values
        );

        this.$emit("update", values);
      } catch (error) {
        this.selectedId = null;
      }

      this.itemLoading = false;
    },
  },

  created() {
    this.load();
    this.selectedId = this.link?.dataset;
  },
});
</script>
